import { Component, Inject, Input, OnInit, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { FunctionService } from 'vhobjects-service/src/services';
import { isPlatformBrowser } from '@angular/common';
import { ThemeService } from 'vhobjects-service';
import { ChooseIconComponent } from 'vhobjects-service';
import { MatDialog } from '@angular/material/dialog';

import {
  DEFAULT_MANAGE_THEME,
  MANAGE_COLOR_GROUPS,
  MANAGE_COLOR_OPTIONS,
  MANAGE_COLOR_SECTIONS,
} from './booking-hotel-manage-config-theme.constants';
import { BOOKING_CONTENT_SECTIONS, STYLES_FIELD } from './booking-hotel-manage-config-content.constants';

@Component({
  selector: 'atw-booking-hotel-manage-config',
  templateUrl: './booking-hotel-manage-config.component.html',
  styleUrls: ['./booking-hotel-manage-config.component.scss'],
})
export class AtwBookingHotelManageConfig implements OnInit {
  @Input() objectChoosing: any; // nhận data từ ndcDynamicInputs truyền về
  @Input() device: any; // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() type: any;

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any; // lưu phần tử được chọn của mảng style_field để hiện thị phần mở rộng cấu hình
  backgroundColor: any = [];

  width: number = 0;
  height: number = 0;
  customize = [];

  // ===== Static config, imported from constants files =====
  readonly styles_field: any[] = STYLES_FIELD;
  readonly manageColorOptions = MANAGE_COLOR_OPTIONS;
  readonly manageColorGroups = MANAGE_COLOR_GROUPS;
  readonly manageColorSections = MANAGE_COLOR_SECTIONS;
  readonly bookingContentSections: any[] = BOOKING_CONTENT_SECTIONS;

  manageTheme: any = { ...DEFAULT_MANAGE_THEME };

  openMap: { [name: string]: boolean } = {
    menu1: true, menu2: false, menu3: false, menu4: false, menu5: false, menu6: false,
    menu7: false, menu8: false, menu9: false, menu10: false, menu11: false, menu12: false,
  };
  openMapSub: { [name: string]: boolean } = { menu1: false, menu2: false };

  /** Trạng thái mở/đóng của từng nhóm nội dung */
  openContentGroup: { [key: string]: boolean } = {
    dang_nhap: true, // nhóm đầu tiên mở sẵn
  };

  /** Trạng thái mở/đóng của từng nhóm màu */
  openColorGroup: { [key: string]: boolean } = {
    chung: true, // nhóm đầu tiên mở sẵn
  };

  constructor(
    private vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
    private vhQueryAutoWeb: VhQueryAutoWeb,
    public themeService: ThemeService,
    private dialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit(): void {
    this.manageTheme = this.buildThemeFromExistingClasses();
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        this.width = document.getElementById(this.objectChoosing._id).clientWidth;
        this.height = document.getElementById(this.objectChoosing._id).clientHeight;
      }
    }, 0);
  }

  /**
   * Hàm này dùng để cho phép mở menu config.
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   */
  openHandler(value: string, isSub = false): void {
    const targetMap = isSub ? this.openMapSub : this.openMap;
    Object.keys(targetMap).forEach((key) => {
      if (key !== value) targetMap[key] = false;
    });
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width height của element sau khi thay đổi
   */
  changeWidthHeight(event): void {
    if (event.width) this.class['booking-selector']['width'] = event.width + 'px';
    if (event.height) this.class['booking-selector']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

  updateClassAndConfig(): void {
    if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = [];
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) {
        this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing);
      }
      if (!this.objectChoosing['fieldUpdate'].includes(this.device + '_class')) {
        this.objectChoosing['fieldUpdate'].push(this.device + '_class');
      }
      if (!this.objectChoosing['fieldUpdate'].includes(this.device + '_config')) {
        this.objectChoosing['fieldUpdate'].push(this.device + '_config');
      }
      return;
    }
    this.updateFields({
      [this.device + '_config']: this.config,
      [this.device + '_class']: this.class,
    });
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text): void {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /** Cập nhật staticdata vào database. */
  updateStaticData(): void {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata }).then((bool) => {});
  }

  /** Cập nhật Setups vào database. */
  updateSetups(): void {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { setups: this.objectChoosing.setups })
      .then((bool) => {});
  }

  /** Hàm update config vào database. */
  updateConfig(): void {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      [this.device + '_config']: this.config,
    });
  }

  /** Hàm update object vào database. */
  updateFields(value): void {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, value).then((bool: any) => {});
  }

  /** Hàm update class vào database. */
  updateClass(): void {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {});
  }

  /** Hàm này thực hiện thêm màu gradient vào array. */
  addGradient(value): void {
    if (/#/.test(value)) {
      const gradient = this.config['background-color'];
      gradient['gradient_arr'].push(`rgba(${this.hexToRGB(value)}, ${gradient.value_range})`);
      this.updateBackgroundRgb();
    }
  }

  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index): void {
    if (this.config['background-color']['gradient_arr'].length > 1) {
      this.config['background-color']['gradient_arr'].splice(index, 1);
      this.updateBackgroundRgb();
    }
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `${r}, ${g}, ${b}`;
  }

  // hàm cập nhật background linear-gradient
  updateBackgroundRgb(): void {
    if (this.config['background-color'].gradient_check) {
      this.class['booking-selector']['background-image'] =
        'linear-gradient(' +
        this.config['background-color']['gradient_direction'] +
        this.config['background-color']['gradient_arr'] +
        ')';
    } else {
      this.class['booking-selector']['background-image'] = 'none';
    }
    this.updateObject();
  }

  /** Hàm update object vào database. */
  updateObject(): void {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
        [this.device + '_config']: this.config,
        staticdata: this.staticdata,
      })
      .then((bool: any) => {});
  }

  /**
   * Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event): void {
    if (isPlatformBrowser(this.platformId)) {
      this.config['background-color'].gradient_type = direction.type;
      this.config['background-color'].gradient_direction = direction.direction;
      this.class['booking-selector']['background-image'] =
        this.config['background-color'].gradient_type +
        '(' +
        this.config['background-color'].gradient_direction +
        this.config['background-color'].gradient_arr.join(',') +
        ')';
      this.updateConfig();
      this.updateClass();
    }
  }

  /**
   * Hàm này dùng để click chọn màu nền của danh sách màu.
   * @param bgColor : trả về màu được chọn
   * @param event : trả về element được active
   */
  chooseBg(bgColor, event, classBg): void {
    if (isPlatformBrowser(this.platformId)) {
      const activeGradient = document.querySelector('.container-color .active') as HTMLElement;
      if (activeGradient) activeGradient.classList.remove('active');
      event.currentTarget.classList.add('active');

      const data_background = this.class[classBg];
      data_background['background-color'] = bgColor.bgColor;
      data_background['background-color'] = `rgba(${this.hexToRGB(
        data_background['background-color'],
      )}, ${this.config['background-color'].value_range})`;
      this.updateObject();
    }
  }

  openDialogChooseIcon(config): void {
    const dialogRef = this.dialog.open(ChooseIconComponent, {
      width: '80vw',
      height: '70vh',
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        config.icon_name = result.icon;
        this.updateConfig();
      }
    });
  }

  /* =========================================================
   * COLOR GROUP UPDATE / APPLY THEME
   * ========================================================= */

  updateManageGroupColor(type: string): void {
    const group = this.manageColorGroups[type];
    if (!group) {
      return;
    }
    const value = this.manageTheme[type];

    group.classes.forEach((className: string) => {
      if (!this.class[className]) {
        this.class[className] = {};
      }
      this.class[className][group.property] = value;
    });

    this.updateClass();
  }

  applyManageTheme(): void {
    Object.keys(this.manageTheme).forEach((key: string) => {
      this.updateManageGroupColor(key);
    });
  }

  /* =========================================================
   * COLOR GROUP UI STATE
   * ========================================================= */

  toggleColorGroup(title: string): void {
    this.openColorGroup[title] = !this.openColorGroup[title];
  }

  isColorGroupOpen(title: string): boolean {
    return !!this.openColorGroup[title];
  }

  toggleContentGroup(title: string): void {
    this.openContentGroup[title] = !this.openContentGroup[title];
  }

  isContentGroupOpen(title: string): boolean {
    return !!this.openContentGroup[title];
  }

  /* =========================================================
   * PRIVATE HELPERS
   * ========================================================= */

  /** Builds the initial theme object from whatever is already saved in `this.class` */
  private buildThemeFromExistingClasses(): any {
    return {
      background: this.class['booking-hotel-manage']?.['background-color'] || DEFAULT_MANAGE_THEME.background,
      textColor: this.class['booking-hotel-manage']?.['color'] || DEFAULT_MANAGE_THEME.textColor,

      cardBackground: this.class['section-card']?.['background'] || DEFAULT_MANAGE_THEME.cardBackground,
      cardBorder: this.class['section-card']?.['border-color'] || DEFAULT_MANAGE_THEME.cardBorder,

      pageTitle: this.class['page-title']?.['color'] || DEFAULT_MANAGE_THEME.pageTitle,
      sectionTitle: this.class['section-title']?.['color'] || DEFAULT_MANAGE_THEME.sectionTitle,
      sectionDescription: this.class['section-description']?.['color'] || DEFAULT_MANAGE_THEME.sectionDescription,

      labelColor: this.class['form-label']?.['color'] || DEFAULT_MANAGE_THEME.labelColor,
      inputBackground: this.class['form-input']?.['background'] || DEFAULT_MANAGE_THEME.inputBackground,
      inputBorder: this.class['form-input']?.['border-color'] || DEFAULT_MANAGE_THEME.inputBorder,
      inputText: this.class['form-input']?.['color'] || DEFAULT_MANAGE_THEME.inputText,

      primaryButtonBackground: this.class['save-btn']?.['background'] || DEFAULT_MANAGE_THEME.primaryButtonBackground,
      primaryButtonText: this.class['save-btn']?.['color'] || DEFAULT_MANAGE_THEME.primaryButtonText,

      outlineButtonBackground: this.class['outline-btn']?.['background'] || DEFAULT_MANAGE_THEME.outlineButtonBackground,
      outlineButtonBorder: this.class['outline-btn']?.['border-color'] || DEFAULT_MANAGE_THEME.outlineButtonBorder,
      outlineButtonText: this.class['outline-btn']?.['color'] || DEFAULT_MANAGE_THEME.outlineButtonText,

      warningButtonBackground: this.class['warning-btn']?.['background'] || DEFAULT_MANAGE_THEME.warningButtonBackground,
      warningButtonBorder: this.class['warning-btn']?.['border-color'] || DEFAULT_MANAGE_THEME.warningButtonBorder,
      warningButtonText: this.class['warning-btn']?.['color'] || DEFAULT_MANAGE_THEME.warningButtonText,

      tableHeaderBackground: this.class['table-header']?.['background'] || DEFAULT_MANAGE_THEME.tableHeaderBackground,
      tableHeaderText: this.class['table-header']?.['color'] || DEFAULT_MANAGE_THEME.tableHeaderText,
      tableHeaderBorder: this.class['table-header']?.['border-bottom-color'] || DEFAULT_MANAGE_THEME.tableHeaderBorder,

      tableCellText: this.class['table-cell']?.['color'] || DEFAULT_MANAGE_THEME.tableCellText,
      tableCellBorder: this.class['table-cell']?.['border-bottom-color'] || DEFAULT_MANAGE_THEME.tableCellBorder,

      successAlertBackground: this.class['booking-alert']?.['background'] || DEFAULT_MANAGE_THEME.successAlertBackground,
      successAlertText: this.class['booking-alert']?.['color'] || DEFAULT_MANAGE_THEME.successAlertText,

      infoMessageBackground: this.class['info-message']?.['background'] || DEFAULT_MANAGE_THEME.infoMessageBackground,
      infoMessageText: this.class['info-message']?.['color'] || DEFAULT_MANAGE_THEME.infoMessageText,

      detailBoxBackground: this.class['detail-box']?.['background'] || DEFAULT_MANAGE_THEME.detailBoxBackground,
      detailBoxBorder: this.class['detail-box']?.['border-color'] || DEFAULT_MANAGE_THEME.detailBoxBorder,

      infoLabel: this.class['info-label']?.['color'] || DEFAULT_MANAGE_THEME.infoLabel,
      infoValue: this.class['info-value']?.['color'] || DEFAULT_MANAGE_THEME.infoValue,

      roomTitle: this.class['room-type-title']?.['color'] || DEFAULT_MANAGE_THEME.roomTitle,
      roomLabel: this.class['room-label']?.['color'] || DEFAULT_MANAGE_THEME.roomLabel,
      roomValue: this.class['room-value']?.['color'] || DEFAULT_MANAGE_THEME.roomValue,

      extraServiceValue: this.class['extra-services-value']?.['color'] || DEFAULT_MANAGE_THEME.extraServiceValue,

      paymentLabel: this.class['payment-label']?.['color'] || DEFAULT_MANAGE_THEME.paymentLabel,
      paymentValue: this.class['payment-value']?.['color'] || DEFAULT_MANAGE_THEME.paymentValue,

      paymentStatusBorder: this.class['payment-status']?.['border-color'] || DEFAULT_MANAGE_THEME.paymentStatusBorder,
      paymentStatusText: this.class['payment-status']?.['color'] || DEFAULT_MANAGE_THEME.paymentStatusText,

      locationLabel: this.class['location-label']?.['color'] || DEFAULT_MANAGE_THEME.locationLabel,
      locationValue: this.class['location-value']?.['color'] || DEFAULT_MANAGE_THEME.locationValue,

      summaryLabel: this.class['summary-label']?.['color'] || DEFAULT_MANAGE_THEME.summaryLabel,
      summaryValue: this.class['summary-value']?.['color'] || DEFAULT_MANAGE_THEME.summaryValue,

      policyText: this.class['policy-text']?.['color'] || DEFAULT_MANAGE_THEME.policyText,
    };
  }
}